import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  getUserSettings(): Observable<any> {
    const url = this.apiData.apiURL + `api/${this.client}/user/settings`;
    return this.http.get<any>(url);
  }

  getUserSettingsForKey(key: string): Observable<any> {
    const url = this.apiData.apiURL + `api/${this.client}/user/settings/${key}`;
    return this.http.get<any>(url);
  }

  setUserSettingsForKey(key: string, value: string): Observable<any> {
    const url = this.apiData.apiURL + `api/${this.client}/user/settings/${key}`;
    const body = { value };
    return this.http.post<any>(url, body);
  }

  deleteUserSettingsForKey(key: string): Observable<any> {
    const url = this.apiData.apiURL + `api/${this.client}/user/settings/${key}`;
    return this.http.delete<any>(url);
  }
}
